import { useCompleteQuizMutation, useUpdateQuizDataMutation } from "@garther/query-hooks";
import { getErrorMessage, toast, useI18n } from "@garther/ui/libs";

export { quizKeys, useQuizzes, useMyQuizData } from "@garther/query-hooks";

export function useCompleteQuiz(options: { onSuccess?: () => void } = {}) {
  const { t } = useI18n();
  return useCompleteQuizMutation({
    onSuccess: () => {
      toast.success(t("quiz.completed"));
      options.onSuccess?.();
    },
    onError: (error) => toast.error(getErrorMessage(error) || t("common.error.tryAgain"))
  });
}

export function useUpdateQuizData(options: { onSuccess?: () => void } = {}) {
  const { t } = useI18n();
  return useUpdateQuizDataMutation({
    onSuccess: options.onSuccess ? () => options.onSuccess!() : undefined,
    onError: (error) => toast.error(getErrorMessage(error) || t("common.error.tryAgain"))
  });
}
